import { combineReducers } from 'redux';
import initialState from './initialState';
import * as types from './types';

const selectedTabReducer = (state = initialState.selectedTab, action) => {
  switch (action.type) {
    case types.SET_ACCOUNT_MODAL_SELECTED_TAB:
      return action.payload;
    default:
      return state;
  }
};

const temporaryMessageReducer = (state = initialState.temporaryMessage, action) => {
  switch (action.type) {
    case types.SET_ACCOUNT_MODAL_TEMPORARY_MESSAGE:
      return action.payload;
    default:
      return state;
  }
};

const emailReducer = (state = initialState.email, action) => {
  switch (action.type) {
    case types.SET_ACCOUNT_MODAL_EMAIL:
      return action.payload;
    default:
      return state;
  }
};

const signInReducer = (state = initialState.signIn, action) => {
  switch (action.type) {
    case types.SIGN_IN_IS_LOADING:
      return {
        ...state,
        isLoading: true
      };
    case types.SET_SIGN_IN_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    default:
      return state;
  }
};

const createAccountReducer = (state = initialState.createAccount, action) => {
  switch (action.type) {
    case types.CREATE_USER_IS_LOADING:
      return {
        ...state,
        isLoading: true
      };
    case types.CREATE_USER_SUCCESS:
      return {
        ...state,
        isLoading: false
      };
    case types.SET_CREATE_USER_ERROR:
      return {
        ...state,
        error: action.payload,
        isLoading: false
      };
    case types.CLEAR_CREATE_USER_ERROR:
      return {
        ...state,
        error: {}
      };
    default:
      return state;
  }
};

const forgotPasswordReducer = (state = initialState.forgotPassword, action) => {
  switch (action.type) {
    case types.FORGOT_PASSWORD_IS_LOADING:
      return {
        ...state,
        isLoading: true
      };
    case types.FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        hasResetPassword: true,
        isLoading: false
      };
    case types.SET_FORGOT_PASSWORD_ERROR:
      return {
        ...state,
        error: action.payload,
        isLoading: false
      };
    case types.CLEAR_FORGOT_PASSWORD_STATE:
      return initialState.forgotPassword;
    default:
      return state;
  }
};

const resetPasswordReducer = (state = initialState.resetPassword, action) => {
  switch (action.type) {
    case types.RESET_PASSWORD_IS_LOADING:
      return {
        ...state,
        isLoading: true
      };
    case types.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        hasResetPassword: true,
        isLoading: false
      };
    case types.SET_RESET_PASSWORD_ERROR:
      return {
        ...state,
        error: action.payload,
        isLoading: false
      };
    case types.CLEAR_RESET_PASSWORD_STATE:
      return initialState.resetPassword;
    case types.SET_RESET_PASSWORD_TOKEN:
      return {
        ...state,
        oneUseToken: action.payload
      };
    default:
      return state;
  }
};

const reducer = combineReducers({
  selectedTab: selectedTabReducer,
  temporaryMessage: temporaryMessageReducer,
  email: emailReducer,
  signIn: signInReducer,
  createAccount: createAccountReducer,
  forgotPassword: forgotPasswordReducer,
  resetPassword: resetPasswordReducer
});

export default reducer;
